<template>
  <div class="home">
    <swiper
      class="full-swiper"
      ref="swiper"
      :options="swiperOptions"
      @ready="handleResize"
      @resize="handleResize"
      @slide-change="handleSlideChange"
    >
      <swiper-slide class="full-swiper-item">
        <Screen1 />
      </swiper-slide>
      <swiper-slide class="full-swiper-item msg-case">
        <div class="content-msg-case">
          <Screen2 />
        </div>
      </swiper-slide>
      <swiper-slide class="full-swiper-item msg-case">
        <div class="content-msg-case">
          <Screen3 />
        </div>
      </swiper-slide>
      <swiper-slide class="full-swiper-item about">
        <div class="content-about">
          <Screen4 />
        </div>

        <Footer
          class="footer"
          v-if="!smallViewPort"
        />
      </swiper-slide>
      <swiper-slide
        v-if="smallViewPort"
        class="full-swiper-item footer"
      >
        <Footer class="footer" />
      </swiper-slide>
    </swiper>

    <div class="pagenation-bar">
      <div class="pagenation-bar-prev">
        <img src="@/assets/icon_up-narrow.png" />
      </div>
      <div class="full-swiper-pagination"></div>
      <div class="pagenation-bar-next">
        <img src="@/assets/icon_down-narrow.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Screen1 from "./screen-1";
import Screen2 from "./screen-2";
import Screen3 from "./screen-3";
import Screen4 from "./screen-4";

import Footer from "./footer";

export default {
  components: {
    Screen1,
    Screen2,
    Screen3,
    Screen4,
    Footer
  },

  data() {
    return {
      smallViewPort: false,

      swiperOptions: {
        touchRatio: 0.3,
        speed: 800,
        direction: "vertical",
        mousewheel: true,
        parallax: true,
        pagination: {
          el: ".full-swiper-pagination",
          bulletActiveClass: "full-swiper-pagination-custom-bullet-active",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} full-swiper-pagination-custom-bullet">${
              this.swiperList[index].title
            }</span>`;
          }
        },
        navigation: {
          nextEl: ".pagenation-bar-next",
          prevEl: ".pagenation-bar-prev"
        }
      },

      swiperList: [
        {
          title: "产品业务"
        },
        {
          title: "信息服务"
        },
        {
          title: "成功案例"
        },
        {
          title: "关于我们"
        },
        {
          title: "联系"
        }
      ]
    };
  },

  computed: {
    swiper() {
      return this.$refs.swiper.swiper;
    }
  },

  watch: {
    $route: "handleSlideTo"
  },

  methods: {
    handleResize() {
      const windowWidth = document.documentElement.offsetWidth;
      if (windowWidth <= 767) {
        this.smallViewPort = true;
      } else {
        this.smallViewPort = false;
      }
    },

    handleSlideChange() {
      let navAnchor;
      switch (this.swiper.activeIndex) {
        case 2:
          this.$bus.emit("changeCurrentSwiperItem", "case");
          break;

        case 3:
          this.$bus.emit("changeCurrentSwiperItem", "about");
          break;

        default:
          this.$bus.emit("changeCurrentSwiperItem", "");
          break;
      }
      this.$router.replace({
        path: this.$route.path,
        query: {
          anchorIndex: this.swiper.activeIndex
        }
      });
    },

    handleSlideTo() {
      if ("anchorIndex" in this.$route.query) {
        const { anchorIndex } = this.$route.query;
        this.swiper.slideTo(anchorIndex);
      }
    }
  },

  mounted() {
    this.handleSlideTo();
  }
};
</script>

<style lang="less">
.home {
  background-image: url("~@/assets/bg_grid.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: inherit;

  .full-swiper,
  .full-swiper-item,
  .about-swiper,
  .about-swiper-item {
    height: inherit;
  }

  .full-swiper {
    &-item {
      &.msg-case {
        display: flex;
        flex-direction: column;
        .content-msg-case {
          flex: 1;
          background-image: url("~@/assets/bg_wave.png");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          overflow: auto;
        }
      }
      &.about {
        display: flex;
        flex-direction: column;

        .content-about {
          flex: 1;
          background-image: url("~@/assets/img_aboutus@2x.png");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          overflow: auto;
        }
      }
    }
  }

  .pagenation-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: calc((100% - 1000px) / 10);
    z-index: 1;
    color: @pagenation-bar-text;

    transform: translate3d(0, -50%, 0);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    .full-swiper-pagination {
      display: flex;
      flex-direction: column;
      right: initial;

      &-custom-bullet {
        margin: 20px 0;
        width: auto;
        height: auto;
        border-radius: initial;
        background: none;
        opacity: initial;
        &:not(:last-child) {
          margin-bottom: 10px;
        }

        &-active {
          color: @active-primary;
        }
      }
    }

    .pagenation-bar-prev,
    .pagenation-bar-next,
    .full-swiper-pagination-custom-bullet {
      outline: none;
      cursor: pointer;
    }
  }

  .footer {
    padding: 20px;
    background: @footer-bg;
  }

  /*@media screen and (min-width: 1400px) and (max-width: 1700px) {*/
  /*.pagenation-bar {*/
  /*left: 12%;*/
  /*}*/
  /*}*/

  /*@media screen and (min-width: 767px) and (max-width: 1400px) {*/
  /*.pagenation-bar {*/
  /*left: 5%;*/
  /*}*/
  /*}*/

  @media screen and (max-width: 1140px) {
    .pagenation-bar {
      display: none;
    }
  }
}
</style>
